// extracted by mini-css-extract-plugin
export default {"page":"EQ","heading":"FQ","subheading":"GQ","flavorbox":"HQ","inner":"IQ","image":"JQ","label":"KQ","flavorselect":"LQ","arrow":"MQ","flavorswrap":"NQ","flavorsheader":"OQ","flavorsnav":"PQ","flavorsinner":"QQ","cancelbtn":"RQ","flavorsbottom":"SQ","retakebtn":"TQ","continueBtn":"UQ","drawerinner":"VQ","videowrap":"WQ","flavorsbottomnav":"XQ"};
    if(module.hot) {
      // 1713361653135
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  